import { useLiveQuery } from 'dexie-react-hooks';
import { PageHeader } from '@/components/PageHeader';
import { Card, Dato, Seccion } from '@/components/Card';
import { leerSettings } from '@/db/schema';
import { VERSION_ESQUEMA } from '@/db/types';

/** Más → Acerca de: versión, perfil de este teléfono y privacidad (estilo Foco). */
export function AboutPage() {
  const settings = useLiveQuery(() => leerSettings(), []);
  const perfilCorto = settings?.perfilId ? `${settings.perfilId.slice(0, 12)}…` : 'Sin crear';

  return (
    <div className="space-y-6">
      <PageHeader
        titulo="DuoFit."
        descripcion="Tu espacio personal para entrenar y cuidar tu progreso."
        volver={{ a: '/mas', texto: 'Volver', etiqueta: 'Volver a Más' }}
      />

      <Card>
        <h2 className="mb-2 text-[22px] leading-tight tracking-[-0.6px] text-texto">
          Hecha para ustedes
        </h2>
        <p className="text-[13px] leading-relaxed text-texto-suave">
          Cada persona conserva sus datos en su teléfono. Nada se sincroniza: los datos salen del
          teléfono solo cuando exportas un respaldo.
        </p>
      </Card>

      <Seccion titulo="Versión">
        <dl className="divide-y divide-borde">
          <Dato etiqueta="Versión de la app" valor={__VERSION_APP__} />
          <Dato etiqueta="Versión de los datos" valor={String(VERSION_ESQUEMA)} />
          <Dato
            etiqueta="Perfil de este teléfono"
            valor={settings?.nombre ?? 'Sin nombre'}
            detalle={`Identificador: ${perfilCorto}`}
          />
        </dl>
      </Seccion>

      <Seccion titulo="Base de alimentos">
        <p className="text-[13px] leading-relaxed text-texto-suave">
          Fuente: U.S. Department of Agriculture, Agricultural Research Service. FoodData Central
          (SR Legacy, abril de 2018, y FNDDS 2021-2023, octubre de 2024), de dominio público. Viene
          incluida en la app y funciona sin conexión. Sus valores son aproximados: los de tus
          alimentos dependen de su marca y de cómo se preparan, y los platillos siguen recetas
          estándar de USDA.
        </p>
      </Seccion>

      <Seccion titulo="Privacidad">
        <ul className="list-disc space-y-2 pl-5 text-[13px] leading-relaxed text-texto-suave">
          <li>Tus datos se guardan solo en este teléfono. No hay cuentas ni servidor con datos.</li>
          <li>
            Cada teléfono tiene su propio perfil y no se sincroniza con otro. Los datos solo salen
            del teléfono cuando tú exportas un respaldo.
          </li>
          <li>
            La app no hace peticiones a internet durante el uso; solo descarga sus propias
            actualizaciones.
          </li>
          <li>El respaldo de iCloud del iPhone no sustituye el respaldo de la app.</li>
        </ul>
      </Seccion>
    </div>
  );
}
